
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
import KeywordProtectedPage from './MyPage';
function Punetooutstationcab() {



    const cardData =
    {
        keyword: 'Pune To Outstation Cab',
        heading: 'Mauli Cabs: Pune To Outstation Cab',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune to outstation cab services, ensuring a comfortable and safe journey to any destination outside Pune. Whether you’re traveling for business, leisure, or a family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a smooth and enjoyable ride for all your outstation travel needs.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
    },
    {
        "title": "Osho Ashram",
        "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
        "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
    },
    {
        "title": "Bund Garden",
        "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
    },
    {
        "title": "Saras Baug",
        "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
    },
    {
        "title": "Fergusson College",
        "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
    }
],



"services": [
    {
        "name": "Pune Outstation Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable outstation cab services from Pune. Whether it's a one-way or round trip, we ensure a hassle-free and smooth journey to your destination."
    },
    {
        "name": "Book Outstation Taxi from Pune",
        "description": "Book your outstation taxi from Pune with Mauli Cabs. We provide easy booking options and ensure a comfortable ride for your journey to any destination outside Pune."
    },
    {
        "name": "Affordable Outstation Cabs from Pune",
        "description": "Mauli Cabs offers affordable and competitive pricing for outstation travel from Pune. Travel comfortably to your destination with transparent pricing and no hidden charges."
    },
    {
        "name": "Private Outstation Taxis from Pune",
        "description": "Travel privately with Mauli Cabs from Pune to any outstation destination. Our private taxi services provide comfort, convenience, and a personalized travel experience."
    },
    {
        "name": "One-Way Outstation Cabs from Pune",
        "description": "Mauli Cabs provides one-way outstation cab services from Pune. Whether you need a one-way journey or a round trip, we offer flexible options to suit your travel needs."
    },
    {
        "name": "Round Trip Outstation Cabs from Pune",
        "description": "Book a round-trip outstation cab with Mauli Cabs from Pune. Our round-trip services ensure a smooth and comfortable journey with convenient pick-ups and drop-offs."
    },
    {
        "name": "Group Travel in Outstation Cabs from Pune",
        "description": "Travel in a group to outstation destinations with Mauli Cabs. Our spacious vehicles are perfect for family or group travel, ensuring comfort and convenience throughout the journey."
    },
    {
        "name": "Pune to Outstation Trip by Taxi",
        "description": "Mauli Cabs offers taxi services for your outstation trips from Pune. Choose from a range of vehicles to ensure a comfortable and safe journey to your destination."
    },
    {
        "name": "Comfortable Outstation Travel by Taxi from Pune",
        "description": "Experience comfortable outstation travel with Mauli Cabs. Our fleet of well-maintained vehicles and professional drivers ensure a smooth and relaxing ride from Pune to your destination."
    },
    {
        "name": "Pune Outstation Transportation Services",
        "description": "Mauli Cabs provides comprehensive outstation transportation services from Pune. Whether you're traveling for business, leisure, or pilgrimage, we offer the best travel experience."
    }
],

"tableData": [
    ["Pune Outstation Cab Service", "Book Outstation Taxi from Pune"],
    ["Affordable Outstation Cabs from Pune", "Private Outstation Taxis from Pune"],
    ["One-Way Outstation Cabs from Pune", "Round Trip Outstation Cabs from Pune"],
    ["Group Travel in Outstation Cabs from Pune", "Pune to Outstation Trip by Taxi"],
    ["Comfortable Outstation Travel by Taxi from Pune", "Pune Outstation Transportation Services"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for all your outstation trips from Pune. Whether you're traveling to nearby cities or exploring distant destinations, our drivers are committed to providing punctual pickups and drop-offs."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your outstation journey from Pune, we offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are air-conditioned, spacious, and well-maintained, providing you with a comfortable ride, no matter the distance."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are skilled in handling outstation trips and familiar with the best routes. They ensure a smooth, safe, and pleasant journey, allowing you to relax and enjoy your travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your outstation travel. We believe in transparent pricing with no hidden charges, so you get the best value for your money without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and pleasant journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for all your outstation cab bookings from Pune. Whether you need an early morning departure or a late-night return, our customer service team is always available to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your outstation cab from Pune with Mauli Cabs is easy and convenient. You can book online via our website or mobile app, or contact our customer service team for personalized assistance to ensure a seamless booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your outstation journey. Whether you're planning a short weekend getaway or a longer exploration of multiple cities, we can tailor the trip to suit your preferences and schedule."
    }
]


















    }



    const faqData = [
        {
            question: 'How do I book an outstation cab from Pune with Mauli Cabs?',
            answer: 'Booking your outstation cab from Pune is easy! You can book directly through our website or mobile app. Just enter Pune as your pickup location and the outstation destination of your choice, then select the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for outstation trips from Pune?',
            answer: 'Mauli Cabs offers a wide range of vehicles for outstation trips, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort preferences, and budget for the journey.',
        },
        {
            question: 'Is the fare for outstation trips from Pune fixed?',
            answer: 'Yes, the fare for outstation trips is fixed and transparent. It includes tolls, taxes, and driver charges with no hidden costs. You will receive the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does an outstation trip from Pune typically take?',
            answer: 'The duration of an outstation trip from Pune varies depending on the destination. For instance, trips to Mumbai, Nashik, or Lonavala typically take around 3 to 5 hours. For longer distances, the journey time may be longer. We ensure that your ride is as smooth and comfortable as possible.',
        },
        {
            question: 'Are the drivers experienced with outstation routes?',
            answer: 'Yes, Mauli Cabs drivers are experienced with various outstation routes. They are familiar with the best roads and take every precaution to ensure a safe and comfortable journey, no matter the destination.',
        },
        {
            question: 'Can I book a round trip for outstation travel from Pune?',
            answer: 'Yes, you can easily book a round trip for your outstation journey from Pune. Just provide your return details when making the booking, and we will ensure a seamless return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing during my outstation trip?',
            answer: 'Yes, you can customize your outstation trip by making stops for sightseeing or taking breaks along the way. Whether you want to visit specific attractions or just need a break, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for comfort and cleanliness. We prioritize your comfort and ensure that you have a pleasant journey throughout your outstation trip.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking after confirmation. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you with any changes.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my outstation trip from Pune?',
            answer: 'Mauli Cabs offers competitive pricing, a wide range of vehicle options, experienced drivers, and professional service. We ensure that your outstation trip is comfortable, safe, and hassle-free, whether it’s for business, leisure, or any other purpose.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Deshmukh",
            position: "Frequent Traveler",
            text: "I booked an outstation trip from Pune with Mauli Cabs and had an amazing experience! The driver was punctual, the car was comfortable, and the whole journey was stress-free. I will definitely choose Mauli Cabs for all my future outstation trips!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Shilpa Agrawal",
            position: "Leisure Traveler",
            text: "Mauli Cabs made our outstation trip from Pune unforgettable! The ride was comfortable, the vehicle was well-maintained, and the driver was professional. We were able to enjoy the scenic route without any worries. I highly recommend them for any outstation travel!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Outstation Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable outstation cab services from Pune. Choose from private taxis, one-way or round-trip options for your outstation travel. Enjoy a smooth and reliable ride to various destinations with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      

    return (
        <div>
            <GTag/>
<KeywordProtectedPage/>

<Helmet>
        <title>Pune to Outstation Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Outstation cab with Mauli Cabs. Choose from affordable, private, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune outstation cab service, Book outstation taxi from Pune, Affordable outstation cabs from Pune, Private outstation taxis from Pune, One-way outstation cabs from Pune, Round trip outstation cabs from Pune, Group travel in outstation cabs from Pune, Pune to outstation trip by taxi, Comfortable outstation travel by taxi from Pune, Pune outstation transportation services"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetooutstationcab;